import { render } from "./WordAddView.vue?vue&type=template&id=c5aedce0&ts=true"
import script from "./WordAddView.vue?vue&type=script&lang=ts"
export * from "./WordAddView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__